var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBlockpix(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 319.812,
    height: 66.523,
    viewBox: "0 0 319.812 66.523",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0057c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0097fb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_75",
    "data-name": "Group 75",
    transform: "translate(-528.443 -4379.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(528.443 4379.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_80",
    "data-name": "Group 80",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_79",
    "data-name": "Group 79"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_154",
    "data-name": "Path 154",
    d: "M560.654,4382.183a2.5,2.5,0,0,1-1.181,1.538l-25.926,14.827-.107,33.163-5-2.93v-33.033l28.518-16.4a2.489,2.489,0,0,1,1.256-.34,2.529,2.529,0,0,1,2.178,1.253A2.489,2.489,0,0,1,560.654,4382.183Z",
    transform: "translate(-528.443 -4379.011)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_155",
    "data-name": "Path 155",
    d: "M560.654,4382.183a2.5,2.5,0,0,1-1.181,1.538l-25.926,14.827-.107,33.163-5-2.93v-33.033l28.518-16.4a2.489,2.489,0,0,1,1.256-.34,2.529,2.529,0,0,1,2.178,1.253A2.489,2.489,0,0,1,560.654,4382.183Z",
    transform: "translate(-528.443 -4379.011)",
    fill: "#00d3be"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_78",
    "data-name": "Group 78",
    transform: "translate(19.034 22.244)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_75-2",
    "data-name": "Group 75"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_156",
    "data-name": "Path 156",
    d: "M591.495,4458.565l9.922-5.869,8.987,5.259-9.841,5.815Z",
    transform: "translate(-591.495 -4452.696)",
    fill: "#00d3be"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_76",
    "data-name": "Group 76",
    transform: "translate(9.068 5.259)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_157",
    "data-name": "Path 157",
    d: "M621.534,4487.278l9.841-5.531v-11.63l-9.841,5.815Z",
    transform: "translate(-621.534 -4470.117)",
    fill: "#00ebd3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_77",
    "data-name": "Group 77",
    transform: "translate(0 5.869)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_158",
    "data-name": "Path 158",
    d: "M591.495,4472.138v11.386l9.068,5.164v-11.345Z",
    transform: "translate(-591.495 -4472.138)",
    fill: "#00b8a5"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_159",
    "data-name": "Path 159",
    d: "M626.567,4408.68v32.952l-28.444,16.753-10.681-6.367v-5.66l10.736,6.289,23.424-13.552v-27.664l-19.355-11.254,4.852-2.757Z",
    transform: "translate(-569.632 -4391.862)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_160",
    "data-name": "Path 160",
    d: "M626.567,4408.68v32.952l-28.444,16.753-10.681-6.367v-5.66l10.736,6.289,23.424-13.552v-27.664l-19.355-11.254,4.852-2.757Z",
    transform: "translate(-569.632 -4391.862)",
    fill: "#00d3be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_161",
    "data-name": "Path 161",
    d: "M578.184,4415.753l-19.3,11.173v40.908a2.355,2.355,0,0,0,4.709.013l.062-15.48,14.584,8.25,19.365-11.257v-22.511Zm14.448,30.936-14.39,8.347-14.717-8.509v-16.692l14.659-8.337,14.448,8.341Z",
    transform: "translate(-549.692 -4404.661)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_162",
    "data-name": "Path 162",
    d: "M578.184,4415.753l-19.3,11.173v40.908a2.355,2.355,0,0,0,4.709.013l.062-15.48,14.584,8.25,19.365-11.257v-22.511Zm14.448,30.936-14.39,8.347-14.717-8.509v-16.692l14.659-8.337,14.448,8.341Z",
    transform: "translate(-549.692 -4404.661)",
    fill: "#00d3be"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(604.337 4397.003)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163",
    "data-name": "Path 163",
    d: "M779.843,4451.538l6.938-1.873v2.9h12.81a2.961,2.961,0,0,0,2.973-1.652,2.854,2.854,0,0,0,.22-1.064,2.38,2.38,0,0,0-1.579-2.313,4.32,4.32,0,0,0-1.615-.293H779.843l1.872-6.2h17.95q5.653,0,8.59,3.487a7.452,7.452,0,0,1,1.872,4.956,6.732,6.732,0,0,1-2.9,5.506,4.637,4.637,0,0,1-.7.514,7.739,7.739,0,0,1,4.258,5.469,6,6,0,0,1,.11,1.1,7.166,7.166,0,0,1-2.936,5.873,11.735,11.735,0,0,1-7.525,2.276H779.843Zm6.938,7.194v5.286h13.581a2.962,2.962,0,0,0,2.973-1.651,2.863,2.863,0,0,0,.22-1.065,2.356,2.356,0,0,0-1.578-2.276,4.323,4.323,0,0,0-1.615-.293Z",
    transform: "translate(-779.843 -4440.305)",
    fill: "#0c1d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_164",
    "data-name": "Path 164",
    d: "M894.748,4441.039h6.938v22.979H922.2l-1.872,6.2H894.748Z",
    transform: "translate(-860.06 -4440.305)",
    fill: "#0c1d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_165",
    "data-name": "Path 165",
    d: "M1023.146,4454.206q0,8.588-6.644,12.554a21.059,21.059,0,0,1-10.939,2.643q-7.966,0-12.627-4.259-4.442-4.074-4.442-10.938,0-8.112,6.02-12.224a19.367,19.367,0,0,1,11.049-3.01q8.663,0,13.4,4.515Q1023.147,4447.489,1023.146,4454.206Zm-27.31,0q0,6.276,4.588,8.039a15.3,15.3,0,0,0,5.506.844q7.819,0,9.434-5.359a13.092,13.092,0,0,0,.44-3.523q0-7.158-6.167-8.553a17.179,17.179,0,0,0-3.708-.367q-7.085,0-9.14,4.038A11.049,11.049,0,0,0,995.836,4454.206Z",
    transform: "translate(-925.506 -4438.862)",
    fill: "#0c1d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_166",
    "data-name": "Path 166",
    d: "M1119.868,4441.039h18.721l-1.872,6.2h-16q-3.158,0-4.809,3.524a12.168,12.168,0,0,0-1.028,5.065q0,4.332,2.2,6.644a4.891,4.891,0,0,0,3.634,1.542h17.876l-1.872,6.2h-16.849a10.875,10.875,0,0,1-9.434-4.992,16.728,16.728,0,0,1-2.9-9.837,15.709,15.709,0,0,1,3.193-10.058A11.214,11.214,0,0,1,1119.868,4441.039Z",
    transform: "translate(-1008.609 -4440.305)",
    fill: "#0c1d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_167",
    "data-name": "Path 167",
    d: "M1239.324,4439.342h9.581l-15.784,14.242,16.518,14.94h-10.315l-11.893-11.123v11.123h-6.938V4440.48l6.938-1.872v11.93Z",
    transform: "translate(-1087.468 -4438.608)",
    fill: "#0c1d2b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_168",
    "data-name": "Path 168",
    d: "M1326.765,4451.538l6.938-1.873v5.14h13.582a2.889,2.889,0,0,0,2.863-2.056,4.79,4.79,0,0,0,.33-1.762,3.675,3.675,0,0,0-1.5-3.267,3.149,3.149,0,0,0-1.688-.477h-20.519l1.872-6.2h18.354a10.383,10.383,0,0,1,8.7,3.964,10.142,10.142,0,0,1,2.129,6.314,9,9,0,0,1-3.047,7.048,11.278,11.278,0,0,1-7.782,2.643H1333.7v9.213h-6.937Z",
    transform: "translate(-1161.657 -4440.305)",
    fill: "#00d3be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_169",
    "data-name": "Path 169",
    d: "M1439.725,4441.039h6.938v29.182h-6.937Z",
    transform: "translate(-1240.516 -4440.305)",
    fill: "#00d3be"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M1488.508,4451.941l9.213-10.9h8.076l-12.26,14.426,12.627,14.756h-8.075l-9.581-11.306-9.581,11.306h-8.075l12.627-14.756-12.26-14.426h8.075Z",
    transform: "translate(-1262.246 -4440.305)",
    fill: "#00d3be"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockpix);
export default __webpack_public_path__ + "static/media/blockpix.e6ddf10d449b541c351edf5cdab1db87.svg";
export { ForwardRef as ReactComponent };